import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';

import { init } from './cameraActions';
import { getGrupoFisicoList } from '../common/selectdb/selectdbAtions';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndSelectForm from '../common/form/labelAndSelectForm';
import Button from '../common/form/button';

const selector = formValueSelector('cameraForm');

function withSelectChange(handler) {
  return props => (
    <LabelAndSelectForm
      {...props}
      input={{
        ...props.input,
        onChange: e => {
          props.input.onChange(e);
          handler(e, props);
        },
      }}
    />
  );
}

class CameraForm extends Component {
  constructor(props) {
    super(props);
    this.handleGrupoFiltroChange = this.handleGrupoFiltroChange.bind(this);
    this.GrupoFiltroSelect = withSelectChange(this.handleGrupoFiltroChange);
  }

  componentDidMount() {
    if (!this.props.gruposList || !this.props.gruposList.length) {
      this.props.getGrupoFisicoList();
    }
  }

  handleGrupoFiltroChange() {
    this.props.change('controlador_id', '');
  }

  renderControladorOptions() {
    const { controladores, grupoFisicoFiltro } = this.props;
    if (!grupoFisicoFiltro) {
      return (
        <option value="" disabled>
          Selecione o grupo físico acima
        </option>
      );
    }

    const controladoresFiltrados = (controladores || []).filter(
      item => Number(item.anel) === 1 && String(item.grupo_fisico_id) === String(grupoFisicoFiltro),
    );

    if (!controladoresFiltrados.length) {
      return (
        <option value="" disabled>
          Nenhum controlador (anel 1) neste grupo
        </option>
      );
    }

    return controladoresFiltrados.map(ctrl => (
      <option key={ctrl.id} value={ctrl.id}>
        {`Ctrl ${String(ctrl.numero_controlador).padStart(2, '0')} — ${ctrl.endereco || 'Sem endereço'}`}
      </option>
    ));
  }

  render() {
    const { handleSubmit, readOnly, grupoFisicoFiltro } = this.props;
    const grupos = this.props.gruposList || [];

    return (
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="box-body">
          {readOnly && (
            <Field name="id" component={LabelAndInput} readOnly label="Código" cols="12 3" placeholder="Código" />
          )}

          <Field
            name="descricao"
            component={LabelAndInput}
            maxLength={120}
            label="Descrição"
            cols="12 6"
            placeholder="Ex: Câmera Detecção Norte"
          />

          <Field name="tipo" component={LabelAndSelectForm} label="Tipo" cols="12 3">
            <option value="deteccao">Detecção</option>
            <option value="monitoramento">Monitoramento</option>
          </Field>

          <Field name="ativo" component={LabelAndSelectForm} label="Ativo" cols="12 3">
            <option value={1}>Sim</option>
            <option value={0}>Não</option>
          </Field>

          <Field
            name="grupo_fisico_filtro"
            component={this.GrupoFiltroSelect}
            label="Grupo físico"
            cols="12 3"
          >
            <option value="">Selecione...</option>
            {grupos.map(g => (
              <option key={g.id} value={String(g.id)}>
                {g.descricao || g.id}
              </option>
            ))}
          </Field>

          <Field
            name="controlador_id"
            component={LabelAndSelectForm}
            label="Controlador"
            cols="12 6"
            disabled={!grupoFisicoFiltro}
          >
            <option value="">Selecione...</option>
            {this.renderControladorOptions()}
          </Field>

          <Field
            name="endereco"
            component={LabelAndInput}
            maxLength={255}
            label="Endereço IP / URL"
            cols="12 6"
            placeholder="Ex: 192.168.1.244 ou URL MJPEG (/api/mjpegvideo.cgi?…)"
          />

          <Field
            name="ordem"
            component={LabelAndInput}
            type="number"
            label="Ordem"
            cols="12 3"
            placeholder="0"
          />
        </div>

        <div className="box-footer">
          <Button type="submit" className={this.props.submitClass} icon="check" label={this.props.submitLabel} />
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
        </div>
      </form>
    );
  }
}

CameraForm = reduxForm({ form: 'cameraForm', destroyOnUnmount: false })(CameraForm);

const mapStateToProps = state => ({
  controladores: state.cameraCad.controladores,
  gruposList: state.grupoFisicoCad && state.grupoFisicoCad.list,
  grupoFisicoFiltro: selector(state, 'grupo_fisico_filtro'),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ init, getGrupoFisicoList, change }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CameraForm);
